//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '../other/Button';
import MtModalFull from '@/components/Modal/MtModalFull'
import Patron from '@/components/forms/Patron'
import PatronImage from '@/components/forms/PatronImage'
import GiftPatron from '@/components/forms/GiftPatron'
import Popup from '@/components/masterpiece/Popup'
import MtArrowLink from '@/components/other/MtArrowLink'
import Viewer360 from '@/components/masterpiece/Viewer360'

export default {
  components: {
    MtArrowLink,
    Popup,
    GiftPatron,
    PatronImage,
    Patron,
    MtModalFull,
    Button,
    Viewer360
  },
  props: {
    masterpiece: {
      type: Object,
      required: true
    }
  },
  inject: ['$activeBlocks', '$activeCommonBlocks'],
  data() {
    return {
      popupOpen: false,
      indexSelected: 0,
      patron: null,
      offset: 0,
      loading: true,
      user: null,
      openGiftPatron: false,
      formError: null,
      path: "",
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    activeBlocks() {
      return this.$activeBlocks()
    },
    activeCommonBlocks() {
      return this.$activeCommonBlocks()
    },
    isVisibleBlock() {
      return (id, bloks) => {
        const array = bloks || []
        const item = array.find((elem) => elem.code === id);
        return item ? item.show : false
      }
    },
    getCurrentPicturesArr() {
      const { pictureThumb, pictureThumb2, picture } = this.masterpiece
      if (pictureThumb2 && pictureThumb2.length) {
        return pictureThumb2
      } else if (pictureThumb && pictureThumb.length) {
        return pictureThumb
      } else {
        return picture
      }
    },
    buttonValue() {
      const { patron, inLoyaltyProgram, inLoyaltyPatronProgram, isOpenedByMe, inCurrentUserMirGallery } = this.masterpiece

      if (inLoyaltyProgram) {
        if ((!this.user || !this.user.loyaltyProgramData.loyaltyProgramMember) && this.isMirVisibleBtn()) {
          return {
            text: this.$t('masterpiece.participateWithMir'),
            color: 'brown',
            action: 'openIframe'
          }
        } else if (!isOpenedByMe && !inCurrentUserMirGallery && (this.user && this.user.loyaltyProgramData.availableMirMasterpiecesCount - this.user.loyaltyProgramData.addedMirMasterpieces > 0)) {
          return {
            text: this.$t('masterpiece.addToGallery'),
            color: 'brown',
            action: 'getMasterpieceToMyCollection'
          }
        }
      } else if (!patron && this.isPatronVisibleBtn()) {
        return {
          text: this.$t('masterpiece.getPatronage'),
          color: 'brown',
          action: 'getPatronMasterpiece'
        }
      } else if (patron && patron.currentUser && !patron.patronByMir && !patron.isGift && !patron.isGiftWaitAnswer) {
        return {
          text: this.$t('masterpiece.givePatronage'),
          color: 'light',
          action: 'giftPartonat',
        }
      }

      return null
    },
    getPatronInfo() {
      const { patron, inLoyaltyPatronProgram, inLoyaltyProgram } = this.masterpiece
      if (patron && patron.anonymous) {
        return {
          name: this.$t('masterpiece.anonymous')
        }
      } else if (patron) {
        return {
          name: `${patron.name} ${patron.surname}`,
          picture: patron.picture,
          id: patron.id
        }
      } else if (inLoyaltyPatronProgram || inLoyaltyProgram) {
        return {
          picture: this.isEn ? '/app/images/logos/mir-logo-en-white.png' : '/app/images/logos/mir-logo-white.svg'
        }
      }
      return null
    }
  },
  mounted() {
    if (this.$cookies.get('token')) {
      this.$axios({
        method: 'get',
        url: `/api/v1/personnel/get/?lang=${this.$i18n.locale || 'ru'}`
      })
        .then(({data}) => {
          this.user = data.data
          this.loading = false
        })
        .catch(err => {
          console.log('ERORRRR', err)
        })
    } else {
      this.loading = false
    }

    if (this.masterpiece.pano360.isSet) {
      const domen = 'https://cdn.tretyakov.ru';
      const url = new URL(this.masterpiece.pano360.pano360[0]);
      const parts = url.pathname.split("/");
      parts.pop();
      this.path = domen + parts.join("/");
    }
  },
  methods: {
    pictureUrl (url) {
      return this.$absoluteImageUrl(url)
    },
    isPatronVisibleBtn() {
      return this.isVisibleBlock('becomepatron', this.activeBlocks)
    },
    isMirVisibleBtn() {
      return this.isVisibleBlock('mir-register', this.activeCommonBlocks)
    },
    buttonActions(action) {
      switch(action) {
        case 'getPatronMasterpiece':
          this.$store.commit('forms/changeGetPatronMasterpiece', this.masterpiece)
          break
        case 'giftPartonat':
          this.openGiftPatron = true
          break
        case 'openIframe':
          if (!this.$cookies.get('token')) {
            this.$store.commit('forms/changeRegistrationWithMir', true)
            this.$store.commit('forms/changeRegistrationPopup', true)
          } else {
            this.$store.commit('openIframe')
          }
          break
        case 'getMasterpieceToMyCollection':
          this.$axios({
            method: 'post',
            url: '/api/v1/user/addMasterpieceLoyalty',
            data: `lang=${this.$i18n.locale || 'ru'}&itemId=${this.$route.params.id}`
          })
          .then(({data}) => {
            if (data.data) {
              window.location.href = '/app/profile/gallery'
            } else {
              console.log(data.error.message)
            }
          })
          break
        default:
          return null
      }
      // $store.commit('changeGetPatronMasterpiece')
    },
    sentGiftParton(email) {
      this.formError = null
      this.$axios({
        method: 'post',
        url: `/api/v1/patronage/sendGift`,
        data: `lang=${this.$i18n.locale || 'ru'}&email=${email}&masterpieceId=${this.masterpiece.id}`
      })
        .then(({data}) => {
          if (data.error) {
            this.formError = data.error.message
          } else {
            this.openGiftPatron = false
            setTimeout(() => {
              this.$store.commit('getConfigForSystemModal', {
                title: this.$t('masterpiece.patronageGiftModalTitle'),
                message: this.$t('masterpiece.patronageGiftModalMessage'),
                buttonText: this.$t('masterpiece.patronageGiftModalButtonText'),
                buttonColor: 'light'
              })
            }, 500)
            this.$emit('gifted')
          }
        })
        .catch(err => {
          this.formError = err.message
        })
    }
  }
}
